export default {
  data () {
    return {
      /* GENERIC */
      showInput: true,

      /* STEP 1 : choose_offer */
      offers: [],
      chosenOfferIdentifier: null,
      tempChosenOfferIdentifier: null,
      new_chosen_offer: null,
      chosen_offer_html: null,

      /* STEP 2: CGA */
      terms_and_conditions: null,
      cga_checked: false,

      /* STEP 3 : devices_infos */
      deviceTemplate: window.isEnvDevelopment ? {
        brand: '',
        model: 'test',
        model_code: '',
        purchase_date: '2025-10-06',
        purchase_price: 1,
        serialNumber: '456ER9855',
        imei: '',
        chosenCategory: null,
        one_category_option: false
      } : {
        brand: '',
        model: '',
        model_code: '',
        purchase_date: '',
        purchase_price: '',
        serialNumber: '',
        imei: '',
        chosenCategory: null,
        one_category_option: false
      },

      date: {
        min: null,
        max: window.moment().startOf('day').format('YYYY-MM-DD')
      },

      data_device: {
        brands: []
      },

      current_delete_device_index: null,
      packs_are_full: false,

      currentDeletePack: null,

      /* STEP 5 : payment infos */
      iban: window.isEnvDevelopment ? 'FR7600000000004293369835706' : null,
      mandate_signature: '1',
      payment_frequency: 'm'
    }
  }
}
